import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Brand } from '../../models/brand/brand-model';
import { Observable } from 'rxjs/Observable';


import { Router } from "@angular/router";


import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class BrandService {
  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }
  private serviceName = 'api/Brand';


  getBrand() {
    return this.http.get(`${this.serviceName}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addBrand(brandModel: Brand,userId:number) {
    

    return this.http.post(`${this.serviceName}/CreateBrand?userId=` + userId, brandModel, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  updateBrand(brandModel: Brand, userId: number) {
    return this.http.post(`${this.serviceName}/UpdateBrand?userId=` + userId, brandModel, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deletebrand(id: string) {
    return this.http.get(`${this.serviceName}/DeleteBrand?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
      //.map((response: Response) => response.json())
      //.catch(this.errorHandler);
  }

  getBrandById(brandId: string) {
    return this.http.get(`${this.serviceName}/GetBrandById?id=` + brandId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  isUniqueName(name: string, id: number) {
    return this.http
      .get(`${this.serviceName}/isUniqueName?name=` + name + '&Id=' + id, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
  getBrandList(searchKeyword: string, PageNumber: number, PageSize: number) {
    return this.http.get(`${this.serviceName}/GetBrandList?searchKeyword=` + searchKeyword + '&PageNumber=' + PageNumber + '&PageSize=' + PageSize, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json()) 
      .catch(this.errorHandler);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/brand/brand.service.ts